<template>
  <Card style="width:850px">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="250">

      <!-- VAT PAYER -->
      <FormItem :label="getSchema('vat_payer').label" prop="vat_payer">
        <i-switch v-model="formData.vat_payer" size="large">
          <!--<span slot="open">On</span>-->
          <!--<span slot="close">Off</span>-->
        </i-switch>
      </FormItem>

      <FormItem>
        <Button type="primary" @click="saveAction()" :disabled="!validForm">Сохранить</Button>
      </FormItem>
      <Spin size="large" fix v-if="loading"></Spin>
    </Form>
  </Card>
</template>

<script>
  import {base_url} from '../../http.js'

  export default {
    name: "companyMailingSettings",
    data() {
      return {
        loading: true,
        baseViewUrl: base_url + '/company/requisites/',
        schema: {},
        rules: {},
        validForm: true,
        formData: {
          vat_payer: '',
        },
      }
    },

    methods: {
      fetchSchema() {
        this.$http
          .options(this.baseViewUrl)
          .then(response => {
            this.schema = response.data.actions.PUT;
            this.getRules();
          })
          .catch(error => {
            this.$Message.error('Ошибка получения схемы');
          })
      },

      fetchInitialData() {
        this.$http
          .get(this.baseViewUrl)
          .then(response => {
            this.formData = response.data;

            for (let field in this.formData) {
              this.formData[field] = response.data[field];
            }

            this.fetchSchema();
          })
          .catch(error => {
            this.$Message.error('Ошибка получения данных');
          })
          .then(() => {
            this.loading = false;
          });
      },

      getSchema(name) {
        return this.schema[name];
      },

      validateForm() {
        this.$refs.formData.validate((valid) => {
          this.validForm = valid;
        });
      },

      saveAction() {
        if (this.validForm) {
          this.save();
        } else {
          this.$Message.error('Некорректно заполнены поля!');
        }
      },

      save() {
        this.loading = true;
        this.$http
          .put(this.baseViewUrl, this.formData)
          .then(response => {
            this.$Message.success('Успешно сохранено');
          })
          .catch(error => {
            this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Для редактирования организации необходимо закрыть все смены на кассах организации'
                });
          })
          .then(() => {
            this.loading = false;
          });
      },

      getRules() {
        for (let field in this.schema) {
          if (this.schema[field].required) {
            this.rules[field] = [
              {
                required: true,
                message: this.schema[field].help_text,
                trigger: 'blur'
              }
            ];

            this.$watch('formData.' + field, function (newValue, oldValue) {
              this.validateForm();
            });


          }
        }
        // this.validateForm();
      },

    },
    created() {
      this.fetchInitialData();
    },
    mounted() {
      // this.validateForm();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/apps/company/companyMailingSettings.vue